// TODO[new-i18n-issue]: a workaround to use build-in validation string map
// as when serveral features import the same ValidationStringMap
// currently the webpack shared bundle strategy will cause the validation string not generated
export const ScheduledOfflineConversionsStringMap = {
  /*
  Will need to figure out Help Ids shown below so that help message displayed is for Offline Conversions, not Feeds
  this.frequencyHelpId = 'pop_BA_AdCustomizerFeeds_Frequency';
  this.timeZoneHelpId = 'pop_BA_AdCustomizerFeeds_TimeZone';
  this.urlHelpId = 'pop_BA_AdCustomizerFeeds_URL';
  this.usernameHelpId = 'pop_BA_AdCustomizerFeeds_Username';
  this.passwordHelpId = 'pop_BA_AdCustomizerFeeds_Password';
  */
  FileColumn: _TL_('File'),
  FrequencyColumn: _TL_('Schedule'),
  StatusColumn: _TL_('Status'),
  ActionsColumn: _TL_('Actions'),
  'Ad editor side panel opened': _TL_('Ad editor side panel opened'),
  'Ad groups': _TL_('Ad groups'),
  Apply: _TL_('Apply'),
  Attributes: _TL_('Attributes'),
  'Available ad groups: {{itemCount}}': _TL_('Available ad groups: {{itemCount}}'),
  BITimeStampNotes_Label: _TL_('Not all metrics are in real time. Clicks and impressions in the last 1 hour, UET conversions in the last 2 hours, and Non-UET conversions (App Install, Offline Conversions) in the last 5 hours might not be included. '),
  BusinessData_PageFeed_Management_Title: _TL_('Page feeds'),
  BusinessData_Title: _TL_('Business data'),
  Button_Delete: _TL_('Delete'),
  CampaignSelector_EmptyList_Content: _TL_('No results to display.'),
  CampaignSelector_List_Header: _TL_('Available campaigns: {{itemCount}}'),
  CampaignSelector_SelectCampaign: _TL_('Select campaign'),
  Campaigns: _TL_('Campaigns'),
  'Campaigns: {{itemCount}}': _TL_('Campaigns: {{itemCount}}'),
  Cancel: _TL_('Cancel'),
  'Click to learn more about {{item}}': _TL_('Click to learn more about {{item}}'),
  'Click to navigate to {{urlName}}': _TL_('Click to navigate to {{urlName}}'),
  'Click to scope to ad group {{adGroupName}}': _TL_('Click to scope to ad group {{adGroupName}}'),
  'Click to scope to campaign {{campaignName}}': _TL_('Click to scope to campaign {{campaignName}}'),
  'Click to scope to experiment {{experimentName}}': _TL_('Click to scope to experiment {{experimentName}}'),
  'Click to scope to feed {{feedName}}': _TL_('Click to scope to feed {{feedName}}'),
  Close: _TL_('Close'),
  ColumnChooser_Add: _TL_('Add'),
  ColumnChooser_AddAll: _TL_('Add all'),
  ColumnChooser_AddAllInList: _TL_('Add all columns'),
  ColumnChooser_AddColumn: _TL_('Add Column {{columnName}}'),
  ColumnChooser_Added: _TL_('Added'),
  ColumnChooser_Apply: _TL_('Apply'),
  ColumnChooser_ApplySavedColumns: _TL_('Apply saved columns'),
  ColumnChooser_AvailableColumnsHeader: _TL_('Available columns'),
  ColumnChooser_Cancel: _TL_('Cancel'),
  ColumnChooser_CancelReplace: _TL_('Cancel'),
  ColumnChooser_ColumnNameAlreadyExistsPrompt: _TL_('There is already a set of columns with this name: {{name}}'),
  ColumnChooser_ConfirmCancel: _TL_('Cancel'),
  ColumnChooser_ConfirmRemove: _TL_('Remove'),
  ColumnChooser_ConfirmReplace: _TL_('Replace'),
  ColumnChooser_CreateColumn: _TL_('Column'),
  ColumnChooser_CustomColumnsCategory: _TL_('Custom Columns'),
  ColumnChooser_DeselectAll: _TL_('Remove all'),
  ColumnChooser_Entry: _TL_('Columns'),
  ColumnChooser_Header: _TL_('Modify columns'),
  ColumnChooser_IfReplaceColumnName: _TL_('Do you want to replace it?'),
  ColumnChooser_ModifyColumns: _TL_('Modify columns'),
  ColumnChooser_PromptBeforeRemove: _TL_('Are you sure you want to remove saved item: {0}'),
  ColumnChooser_Remove: _TL_('Remove'),
  ColumnChooser_RemoveAllInList: _TL_('Remove all columns'),
  ColumnChooser_RemoveColumn: _TL_('Remove Column {{columnName}}'),
  ColumnChooser_RemoveSavedColumns: _TL_('Remove'),
  ColumnChooser_ReplaceColumnSetName: _TL_('Do you want to replace it?'),
  ColumnChooser_SaveColumnDescription: _TL_('Save this set of columns'),
  ColumnChooser_SelectedColumns: _TL_('Selected columns'),
  ColumnChooser_SelectedColumnsHeader: _TL_('Selected columns (drag and drop to reorder)'),
  Column_StringList_AndMore: _TL_('(and {{remainingItems}} more)'),
  ColumnsMenu_Custom: _TL_('Custom'),
  ColumnsMenu_PromptBeforeRemove: _TL_('Are you sure you want to remove saved item: {0}'),
  Control_PaneHelp_LearnMore: _TL_('Learn more'),
  Conversions: _TL_('Conversions'),
  CronFormatter_FrequencyGrain_DropdownMenu_Daily: _TL_('Daily'),
  CronFormatter_FrequencyGrain_DropdownMenu_Every_6_Hours: _TL_('Every 6 hours'),
  CronFormatter_FrequencyGrain_DropdownMenu_Every_12_Hours: _TL_('Every 12 hours'),
  CronFormatter_FrequencyGrain_DropdownMenu_Monthly: _TL_('Monthly'),
  CronFormatter_FrequencyGrain_DropdownMenu_None: _TL_('Select...'),
  CronFormatter_FrequencyGrain_DropdownMenu_Weekly: _TL_('Weekly'),
  CronFormatter_FrequencyGrain_Runs_Daily: _TL_('daily'),
  CronFormatter_FrequencyGrain_Runs_Every_6_Hours: _TL_('every 6 hours'),
  CronFormatter_FrequencyGrain_Runs_Every_12_Hours: _TL_('every 12 hours'),
  CronFormatter_FrequencyGrain_Runs_Monthly: _TL_('monthly'),
  CronFormatter_FrequencyGrain_Runs_Weekly: _TL_('weekly'),
  CronFormatter_Frequency_DailyTemplate: _TL_('Runs {{frequency}} at {{hour}}'),
  CronFormatter_Frequency_MonthlyTemplate: _TL_('Runs {{frequency}} on day {{dayOfMonth}} at {{hour}}'),
  CronFormatter_Frequency_Template_Every_N_Hours: _TL_('Runs {{frequency}}'),
  CronFormatter_Frequency_WeeklyTemplate: _TL_('Runs {{frequency}} on {{dayOfWeek}} at {{hour}}'),
  CronFrequencyEditor_Daily_Template: _TL_('at {{hour}}'),
  CronFrequencyEditor_Monthly_Template: _TL_('on day {{dayOfMonth}} of every month at {{hour}}'),
  CronFrequencyEditor_Weekly_Template: _TL_('on {{dayOfWeek}} at {{hour}}'),
  DateFilter_Button_Apply: _TL_('Apply'),
  DateFilter_Label_CompareTo: _TL_('Compare to'),
  DateFilter_Option_AllTime: _TL_('Entire time'),
  DateFilter_Option_Custom: _TL_('Custom'),
  DateFilter_Option_CustomPeriod: _TL_('Custom'),
  DateFilter_Option_Last3Months: _TL_('Last 3 months'),
  DateFilter_Option_Last6Months: _TL_('Last 6 months'),
  DateFilter_Option_Last7days: _TL_('Last 7 days'),
  DateFilter_Option_Last14Days: _TL_('Last 14 days'),
  DateFilter_Option_Last30Days: _TL_('Last 30 days'),
  DateFilter_Option_LastMonth: _TL_('Last month'),
  DateFilter_Option_LastWeekMonday: _TL_('Last week (Mon - Sun)'),
  DateFilter_Option_LastWeekSunday: _TL_('Last week (Sun - Sat)'),
  DateFilter_Option_LastYear: _TL_('Last year'),
  DateFilter_Option_PreviousPeriod: _TL_('Previous period'),
  DateFilter_Option_SamePeriodLastYear: _TL_('Same period last year'),
  DateFilter_Option_ThisMonth: _TL_('This month'),
  DateFilter_Option_ThisWeekMonday: _TL_('This week (Mon - Today)'),
  DateFilter_Option_ThisWeekSunday: _TL_('This week (Sun - Today)'),
  DateFilter_Option_ThisYear: _TL_('This year'),
  DateFilter_Option_Today: _TL_('Today'),
  DateFilter_Option_Yesterday: _TL_('Yesterday'),
  DateFilter_RangeSeparator: _TL_(': '),
  DateFilter_StartEndDateSeparator: _TL_(' -  '),
  DayOfWeek_AllDays: _TL_('All days'),
  DayOfWeek_Friday: _TL_('Friday'),
  DayOfWeek_Monday: _TL_('Monday'),
  DayOfWeek_MondayToFriday: _TL_('Monday to Friday'),
  DayOfWeek_Saturday: _TL_('Saturday'),
  DayOfWeek_Sunday: _TL_('Sunday'),
  DayOfWeek_Thursday: _TL_('Thursday'),
  DayOfWeek_Tuesday: _TL_('Tuesday'),
  DayOfWeek_Wednesday: _TL_('Wednesday'),
  DeliveryStatusIcon_Tooltip_Error: _TL_('Error'),
  DeliveryStatusIcon_Tooltip_Warning: _TL_('Warning'),
  'Deselect all': _TL_('Deselect all'),
  'Deselect this row': _TL_('Deselect this row'),
  DoubleListBox_DeselectAll: _TL_('Remove all'),
  EntitySelector_Pagination_NextPageText: _TL_('Next page'),
  EntitySelector_Pagination_Page: _TL_('Page:'),
  EntitySelector_Pagination_PreviousPageText: _TL_('Previous page'),
  EntitySelector_Pagination_TotalPageCountText: _TL_('of'),
  EntitySelector_Search_Placeholder: _TL_('Search'),
  EntityStatus_Enabled: _TL_('Enabled'),
  EntityStatus_Paused: _TL_('Paused'),
  EntityStatus_AriaLabel_Enabled: _TL_('Enable this entity'),
  EntityStatus_AriaLabel_Paused: _TL_('Pause this entity'),
  'ErrorNumber_-1': _TL_('We\'ve encountered an error and can\'t continue. Please contact support for further assistance.'),
  Error_Campaign_API_FiltersExceedsMaxCount: _TL_('Filter is not saved. Cannot save more than {0} filters'),
  Feeds_AdCustomizerItemPage_Tab_Title_Items: _TL_('Ad customizer feed items'),
  Feeds_AdCustomizerPage_AdCustomizer_Description: _TL_('Ad customizers are parameters that adapt your ad to the context of a user\'s search or the webpage someone\'s browsing. '),
  Feeds_AdCustomizerPage_AdCustomizer_Title: _TL_('Ad customizer feeds'),
  Feeds_AdCustomizerPage_FeedItemsPage_Attributes_Description: _TL_('Custom attributes: '),
  Feeds_AdCustomizerPage_FeedUpload_Create_Title: _TL_('Upload an ad customizer feed file'),
  Feeds_AdCustomizerPage_FeedUpload_UpdateAndReplace_Description: _TL_('You can update or replace the items in your ad customizer feed in bulk by uploading a spreadsheet.'),
  Feeds_AdCustomizerPage_FeedsGrid_NoResults_Empty: _TL_('No ad customizer feeds have been uploaded. Click “Upload” to get started.'),
  Feeds_AdCustomizerPage_FeedsGrid_Toolbar_FeedUpload_Title: _TL_('Upload ad customizer feed file'),
  Feeds_AdCustomizerPage_Searchbox_Placeholder: _TL_('Attribute'),
  Feeds_AdCustomizerPage_Tab_Title_Items: _TL_('Ad customizer feeds'),
  Feeds_AdCustomizerPage_UpdateAndReplace_UploadType_Replace_Description: _TL_('Replace all of your ad customizer feed’s items.'),
  Feeds_AdCustomizerPage_UpdateAndReplace_UploadType_Update_Description: _TL_('Add, change, or remove values of some of your ad customizer feed items.'),
  Feeds_DynamicDataItemPage_Tab_Title_Items: _TL_('Dynamic data feed items'),
  Feeds_DynamicDataPage_DynamicDataAutosAggregateFeed_Column_Name: _TL_('Auto aggregate inventory'),
  Feeds_DynamicDataPage_DynamicDataAutosListingFeed_Column_Name: _TL_('Auto listing inventory'),
  Feeds_DynamicDataPage_DynamicDataEventsFeed_Column_Name: _TL_('Events'),
  Feeds_DynamicDataPage_DynamicDataHotelsAndVacationRentalsFeed_Column_Name: _TL_('Hotels/vacation rentals'),
  Feeds_DynamicDataPage_DynamicDataToursAndActivitiesFeed_Column_Name: _TL_('Tours and activities'),
  Feeds_DynamicDataPage_DynamicData_Description: _TL_('Description line. Explain what\'s the next step after this.'),
  Feeds_DynamicDataPage_DynamicData_Title: _TL_('Dynamic data feeds'),
  Feeds_DynamicDataPage_FeedItemsPage_Attributes_Description: _TL_('Attributes: '),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataAutosAggregateFeed_Create_Title: _TL_('Upload a dynamic data auto aggregate feed file'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataAutosAggregateFeed_Dropdown_Name: _TL_('Aggregate inventory'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataAutosListingFeed_Create_Title: _TL_('Upload a dynamic data auto listing feed file'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataAutosListingFeed_Dropdown_Name: _TL_('Listing inventory'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataAutos_Dropdown_Name: _TL_('Autos'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataEventsFeed_Create_Title: _TL_('Upload a dynamic data events feed file'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataEventsFeed_Dropdown_Name: _TL_('Events'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataHotelsAndVacationRentalsFeed_Create_Title: _TL_('Upload a dynamic data hotels and vacation rentals feed file'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataHotelsAndVacationRentalsFeed_Dropdown_Name: _TL_('Hotels/vacation rentals'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataToursAndActivitiesFeed_Create_Title: _TL_('Upload a dynamic data tours and activities feed file'),
  Feeds_DynamicDataPage_FeedUpload_DynamicDataToursAndActivitiesFeed_Dropdown_Name: _TL_('Tours and activities'),
  Feeds_DynamicDataPage_FeedUpload_UpdateAndReplace_Description: _TL_('You can update or replace the items in your dynamic data feed in bulk by uploading a spreadsheet.'),
  Feeds_DynamicDataPage_FeedsGrid_NoResults_Empty: _TL_('No dynamic data feeds have been uploaded. Click “Upload” to get started.'),
  Feeds_DynamicDataPage_FeedsGrid_Toolbar_FeedUpload_Title: _TL_('Upload'),
  Feeds_DynamicDataPage_Searchbox_Placeholder: _TL_('Attribute'),
  Feeds_DynamicDataPage_Tab_Title_Items: _TL_('Dynamic data feeds'),
  Feeds_DynamicDataPage_UpdateAndReplace_UploadType_Replace_Description: _TL_('Replace all of your dynamic data feed’s items.'),
  Feeds_DynamicDataPage_UpdateAndReplace_UploadType_Update_Description: _TL_('Add, change, or remove values of some of your  dynamic data feed items.'),
  Feeds_Error_Hint_Prefix: _TL_('Specific to:'),
  Feeds_FeedItemsGrid_ClickToRefresh_IconText: _TL_('Click to refresh'),
  Feeds_FeedItemsGrid_ClickToRefresh_Message: _TL_('Your feed has finished updating'),
  Feeds_FeedItemsGrid_Column_Status_Caption_Active: _TL_('Active'),
  Feeds_FeedItemsGrid_Column_Status_Caption_Deleted: _TL_('Deleted'),
  Feeds_FeedItemsGrid_Filtered_Total: _TL_('Filtered total - {{number}} feed items'),
  Feeds_FeedItemsGrid_NoResults_AfterFilter: _TL_('No results, please change filter'),
  Feeds_FeedItemsGrid_NoResults_Empty: _TL_('No data'),
  Feeds_FeedItemsGrid_QuickFilterEntry_Active: _TL_('All but removed'),
  Feeds_FeedItemsGrid_QuickFilterEntry_All: _TL_('All'),
  Feeds_FeedItemsGrid_Searchbox_Placeholder: _TL_('Attribute'),
  Feeds_FeedItemsGrid_Total: _TL_('Overall total - {{number}} feed items'),
  Feeds_FeedItemsPage_AddAttribute_LinkText: _TL_('+ Add attribute'),
  Feeds_FeedItemsPage_AddAttribute_NameField_Label: _TL_('Name'),
  Feeds_FeedItemsPage_AddAttribute_Title: _TL_('Add new attribute'),
  Feeds_FeedItemsPage_AddAttribute_TypeField_Label: _TL_('Type'),
  Feeds_FeedItemsPage_AddItem_Button_Cancel: _TL_('Cancel'),
  Feeds_FeedItemsPage_AddItem_Button_Save: _TL_('Save'),
  Feeds_FeedItemsPage_AddItem_Item_Date: _TL_('{{name}} (date)'),
  Feeds_FeedItemsPage_AddItem_Item_Number: _TL_('{{name}} (number)'),
  Feeds_FeedItemsPage_AddItem_Item_Price: _TL_('{{name}} (price)'),
  Feeds_FeedItemsPage_AddItem_Item_Text: _TL_('{{name}} (text)'),
  Feeds_FeedItemsPage_AddItem_Item_TextList: _TL_('{{name}} (text list)'),
  Feeds_FeedItemsPage_AddItem_Item_URL: _TL_('{{name}} (url)'),
  Feeds_FeedItemsPage_AddItem_Title: _TL_('Add item'),
  Feeds_FeedItemsPage_Attributes_Description: _TL_('Attributes: '),
  Feeds_FeedItemsPage_BackToAdCustomizerLink: _TL_('Back to ad customizer feeds'),
  Feeds_FeedItemsPage_BackToDynamicDataLink: _TL_('Back to dynamic data'),
  Feeds_FeedItemsPage_BackToFeedsLink: _TL_('Back to page feeds'),
  Feeds_FeedItemsPage_Description: _TL_('View and manage feed items'),
  Feeds_FeedItemsPage_String_List_Number: _TL_('number {{number}}'),
  Feeds_FeedItemsPage_String_List_Remove: _TL_('Remove'),
  Feeds_FeedItemsPage_Title: _TL_('Feed items'),
  Feeds_FeedItemsPage_Toolbar_AddItem_Title: _TL_('Add item'),
  Feeds_FeedItemsPage_Toolbar_DeleteItem_Confirmation: _TL_('Are you sure you want to delete the selected feed item(s)?'),
  Feeds_FeedItemsPage_Toolbar_DeleteItem_Title: _TL_('Remove'),
  Feeds_FeedItemsPage_Toolbar_FeedUpload_Title: _TL_('Upload spreadsheet'),
  Feeds_FeedItemsPage_URL_PROTOCOL_Label: _TL_('URL protocol'),
  SchedulesTab_Frequency_Label: _TL_('Upload frequency'),
  Feeds_FeedItems_SchedulesTab_HeaderText: _TL_('Save time and streamline your Offline Conversions management by scheduling Offline Conversions uploads.'),
  Feeds_FeedItems_SchedulesTab_Last_Upload_Time_Label: _TL_('Last update'),
  SchedulesTab_Password_Label: _TL_('Password (optional)'),
  TimeZone_Label: _TL_('Time zone'),
  SchedulesTab_URL_InsecureProtocolWarning: _TL_('We recommend using HTTPS and SFTP instead of HTTP or FTP for your customers’ privacy and security'),
  Feeds_FeedItems_SchedulesTab_URL_Label: _TL_('URL'),
  Feeds_FeedItems_SchedulesTab_UpdateNowButton_Text: _TL_('Update now'),
  Feeds_FeedItems_SchedulesTab_Update_Now_Queued_Alert_Text: _TL_('Your Offline Conversions file is getting processed. Once the file processing is complete, please refresh the page to see the most up-to-date changes in the table.'),
  SchedulesTab_Username_Label: _TL_('Username (optional)'),
  Feeds_FeedPage_DynamicData_Description: _TL_('Description line. Explain what\'s the next step after this.'),
  Feeds_FeedPage_FeedsGrid_Header_Id: _TL_('Feed ID'),
  Feeds_FeedPage_FeedsGrid_Header_Last_Update: _TL_('Last update'),
  Feeds_FeedPage_FeedsGrid_Header_Name: _TL_('Name'),
  Feeds_FeedPage_FeedsGrid_Header_Schedule: _TL_('Schedule'),
  Feeds_FeedPage_FeedsGrid_Header_Status: _TL_('Status'),
  Feeds_FeedPage_FeedsGrid_Header_Type: _TL_('Feed Type'),
  Feeds_FeedPage_FeedsGrid_NoResults_Empty: _TL_('No page feeds have been uploaded. Click “Upload” to get started.'),
  Feeds_FeedPage_FeedsGrid_NoResults_Filter: _TL_('No page feeds match your current filtered search. Please revise your search.'),
  Feeds_FeedPage_FeedsGrid_Schedule_Paused: _TL_('Paused'),
  Feeds_FeedPage_FeedsGrid_Status_Active: _TL_('Active'),
  Feeds_FeedPage_FeedsGrid_Status_Deleted: _TL_('Deleted'),
  Feeds_FeedPage_FeedsGrid_Status_Filter_Active: _TL_('All but removed'),
  Feeds_FeedPage_FeedsGrid_Status_Filter_All: _TL_('All feeds'),
  Feeds_FeedPage_FeedsGrid_Toolbar_FeedDelete_Confirmation: _TL_('Are you sure you want to delete the selected feed(s)?'),
  Feeds_FeedPage_FeedsGrid_Toolbar_FeedDelete_Error: _TL_('The selected feeds has deleted feed(s) and cannot be deleted again.'),
  Feeds_FeedPage_FeedsGrid_Toolbar_FeedRemove_Title: _TL_('Remove'),
  Feeds_FeedPage_FeedsGrid_Toolbar_FeedUpload_Title: _TL_('Upload'),
  Feeds_FeedPage_PageFeeds_Description: _TL_('Page feeds enable you to easily target specific webpages in Dynamic Search Ad campaigns. '),
  Feeds_FeedPage_PageFeeds_Title: _TL_('Page feeds'),
  Feeds_FeedPage_Tab_Title_UploadHistory: _TL_('Upload history'),
  Feeds_FeedUpload_AcceptFormat_Label: _TL_('Accepted formats: csv, tsv, xlsx, zip.'),
  Feeds_FeedUpload_Button_ApplyChanges: _TL_('Apply changes'),
  Feeds_FeedUpload_Button_Cancel: _TL_('Cancel'),
  Feeds_FeedUpload_Button_Done: _TL_('Done'),
  Feeds_FeedUpload_Button_DownloadErrors: _TL_('Download errors only'),
  Feeds_FeedUpload_Button_DownloadResult: _TL_('Download results file'),
  Feeds_FeedUpload_Button_RunInBackground: _TL_('Run in background'),
  Feeds_FeedUpload_Button_UploadAndApply: _TL_('Upload and apply'),
  Feeds_FeedUpload_Button_UploadAndPreview: _TL_('Upload and preview'),
  Feeds_FeedUpload_Create_Name_Label: _TL_('Name'),
  Feeds_FeedUpload_Create_Title: _TL_('Upload'),
  Feeds_FeedUpload_LearnMoreText: _TL_('Learn more'),
  Feeds_FeedUpload_PercentageFormatter: _TL_('{{percentage}}%'),
  Feeds_FeedUpload_Preview_Note: _TL_('You can see the status of your upload on the Upload history tab.'),
  Feeds_FeedUpload_RunInBackGround_Notification_Error_Text: _TL_('Your upload failed due to an intermittent network or internal system issue. Please try again shortly.'),
  Feeds_FeedUpload_RunInBackGround_Notification_Text: _TL_('Your upload is running. Check the Upload history table for status.'),
  Feeds_FeedUpload_SampleFile_Label: _TL_('Sample file'),
  Feeds_FeedUpload_Status_Apply: _TL_('Processing'),
  Feeds_FeedUpload_Status_Preview: _TL_('Previewing'),
  Feeds_FeedUpload_Status_Upload: _TL_('Uploading'),
  Feeds_FeedUpload_UpdateAndReplace_Description: _TL_('You can update or replace the items in your page feed by uploading a spreadsheet. '),
  Feeds_FeedUpload_UpdateAndReplace_UploadType_Label: _TL_('Upload type'),
  Feeds_FeedUpload_UpdateAndReplace_UploadType_LearnMoreText: _TL_('Learn more'),
  Feeds_FeedUpload_UpdateAndReplace_UploadType_Replace_Description: _TL_('Replace all of your page feed’s items.'),
  Feeds_FeedUpload_UpdateAndReplace_UploadType_Replace_Label: _TL_('Replace'),
  Feeds_FeedUpload_UpdateAndReplace_UploadType_Update_Description: _TL_('Add, change, or remove values of some of your page feed items.'),
  Feeds_FeedUpload_UpdateAndReplace_UploadType_Update_Label: _TL_('Update'),
  Feeds_FeedUpload_UpdateAndReplace_Upload_IncludeActionAndItemID: _TL_('Include "Action" and "Item ID" columns.'),
  Feeds_FeedUpload_Upload_Label: _TL_('File to upload'),
  Feeds_FeeditemsPage_Tab_Title_Schedules: _TL_('Schedules'),
  Feeds_FeeditemsPage_Tab_Title_UploadHistory: _TL_('Upload history'),
  Feeds_InlinEdit_Date_Format_Hint: _TL_('Format: yyyy/MM/dd hh:mm:ss'),
  Feeds_InlinEdit_Price_Format_Hint: _TL_('Format: {{currency}} 123 or {{currencySymbol}} 246'),
  Feeds_InlinEdit_Schedule_NoTargetSchedule: _TL_('No schedule'),
  Feeds_InlinEdit_Schedule_WithTargetSchedule: _TL_('With selected schedule'),
  Feeds_InlinEdit_TargetAdGroup_NoTargetAdGroups: _TL_('No adgroup target'),
  Feeds_InlinEdit_TargetAdGroup_WithTargetAdGroups: _TL_('Target selected adgroup'),
  Feeds_InlinEdit_TargetCampaign_NoTargetCampaign: _TL_('No campaign target'),
  Feeds_InlinEdit_TargetCampaign_WithTargetCampaign: _TL_('Target selected campaign'),
  Feeds_InlinEdit_TargetLocation_NoSearchResult: _TL_('No location found based on your input, please input another one'),
  Feeds_InlineEdit_Button_Add: _TL_('+ Add'),
  Feeds_InlineEdit_Button_Cancel: _TL_('Cancel'),
  Feeds_InlineEdit_Button_Save: _TL_('Save'),
  Feeds_InlineEdit_Date_InvalidDateSchema: _TL_('Please input value with format yyyy/MM/dd hh:mm:ss'),
  Feeds_InlineEdit_Number_InvalidNumberSchema: _TL_('Please input a valid integer.'),
  Feeds_InlineEdit_Price_InvalidPriceSchema: _TL_('Please input a valid currency where currency symbol are at beginning or end'),
  Feeds_PageFeeds_FeedItemsPage_Tab_Title_Items: _TL_('Page feed items'),
  Feeds_PageFeeds_FeedPage_Tab_Title_Items: _TL_('Page feeds'),
  Feeds_Preference_Init_Error_RequestFailed: _TL_('Your request failed due to an intermittent network or internal system issue. Please try again shortly.'),
  Feeds_UploadHistoryGrid_Actions_ApplyChanges: _TL_('Apply changes'),
  Feeds_UploadHistoryGrid_Actions_DiscardChanges: _TL_('Discard changes'),
  Feeds_UploadHistoryGrid_Actions_DownloadAllResults: _TL_('Download all results'),
  Feeds_UploadHistoryGrid_Actions_DownloadErrors: _TL_('Download errors'),
  Feeds_UploadHistoryGrid_Actions_DownloadErrorsOnly: _TL_('Download errors only'),
  Feeds_UploadHistoryGrid_Actions_DownloadPreview: _TL_('Download preview'),
  Feeds_UploadHistoryGrid_Actions_DownloadResults: _TL_('Download results'),
  Feeds_UploadHistoryGrid_Data_Lost: _TL_('The historical data is not available'),
  Feeds_UploadHistoryGrid_Dialog_Action_ApplyChanges_Body: _TL_('Are you sure you want to apply the upload?'),
  Feeds_UploadHistoryGrid_Dialog_Action_ApplyChanges_Title: _TL_('Applying upload'),
  Feeds_UploadHistoryGrid_NoResults_Empty: _TL_('There is no upload history, please upload your feeds.'),
  Feeds_UploadHistoryGrid_Summary_ApplyUpload: _TL_('Applying upload...'),
  Feeds_UploadHistoryGrid_Summary_Errors: _TL_('{{errorsCount}} errors'),
  Feeds_UploadHistoryGrid_Summary_ErrorsExpected: _TL_('{{errorsCount}} errors expected'),
  Feeds_UploadHistoryGrid_Summary_GeneratePreview: _TL_('Generating preview...'),
  Feeds_UploadHistoryGrid_Summary_InputError: _TL_('Input error'),
  Feeds_UploadHistoryGrid_Summary_NoChanges: _TL_('No changes'),
  Feeds_UploadHistoryGrid_Summary_PreviewedRows: _TL_('Previewed {{totalCount}} rows'),
  Feeds_UploadHistoryGrid_Summary_ReadyToApply: _TL_('Ready to apply'),
  Feeds_UploadHistoryGrid_Summary_Successful: _TL_('{{successCount}} successful'),
  Feeds_UploadHistoryGrid_Summary_ValidChange: _TL_('{{successCount}} valid changes'),
  Feeds_UploadSummaryGrid_Content_Description_Apply: _TL_('Item changes'),
  Feeds_UploadSummaryGrid_Content_Description_Preview: _TL_('Expected item changes'),
  FilePicker_ButtonText_ChooseFile: _TL_('Browse...'),
  FilePicker_FileExtensionInvalid: _TL_('File extension is invalid'),
  Filter: _TL_('Filter'),
  Filter_Apply_Saved_Filters: _TL_('Apply saved filters'),
  Filter_Create_Filter: _TL_('Create filter'),
  Filter_FilterNameWaterMark: _TL_('Optional: type a filter name'),
  Filter_Key_AriaLabel: _TL_('What to filter'),
  Filter_Operator_AriaLabel: _TL_('How to filter'),
  Filter_Operator_AttributeValuesContain: _TL_('contain'),
  Filter_Operator_AttributeValuesNotContain: _TL_('do not contain'),
  Filter_Operator_Contains: _TL_('contains'),
  Filter_Operator_EQ: _TL_('equals'),
  Filter_Operator_EndsWith: _TL_('ends with'),
  Filter_Operator_GT: _TL_('greater than'),
  Filter_Operator_GTE: _TL_('greater than or equals'),
  Filter_Operator_IN: _TL_('either of'),
  Filter_Operator_LT: _TL_('less than'),
  Filter_Operator_LTE: _TL_('less than or equals'),
  Filter_Operator_NEQ: _TL_('does not equal'),
  Filter_Operator_Not_Contains: _TL_('does not contain'),
  Filter_Operator_StartsWith: _TL_('begins with'),
  Filter_PredicateList_New: _TL_('Add another'),
  Filter_Remove: _TL_('Remove'),
  Filter_Title: _TL_('Filter'),
  Filter_Validation_Common_Date: _TL_('Incorrect date format'),
  Filter_Validation_Common_Integer: _TL_('Only integer values allowed'),
  Filter_Validation_Common_Number: _TL_('Only numeric values allowed'),
  Filter_Validation_Common_Number_Range: _TL_('Numeric value out of allowed range'),
  Filter_Validation_Common_Pattern: _TL_('Value should match pattern {0}'),
  Filter_Validation_Common_Required: _TL_('Required field'),
  Filter_Validation_EnumSelectionRequired: _TL_('Select at least one option'),
  Filter_Value_AriaLabel: _TL_('What to filter on'),
  Filters: _TL_('Filters'),
  FiltersMenu_PromptBeforeRemove: _TL_('Are you sure you want to remove the saved item: {0}'),
  Filters_Replace: _TL_('Replace'),
  Filters_SaveFilter: _TL_('Save filter'),
  Form_CancelButton: _TL_('Cancel'),
  Form_SaveButton: _TL_('Save and preview'),
  'Found {{totalCount}} Results for {{searchText}}': _TL_('Found {{totalCount}} Results for {{searchText}}'),
  GridToolbar_FilterBar_Edit: _TL_('Edit'),
  GridToolbar_FilterBar_Loading: _TL_('Loading...'),
  GridToolbar_FilterBar_LoadingError: _TL_('We\'ve encountered an error. Please try again or contact support.'),
  GridToolbar_FilterBar_Remove: _TL_('Remove'),
  GridToolbar_FilterBar_Title: _TL_('Filter'),
  Grid_ColumnChooser_AddAllColumns: _TL_('Add all columns'),
  Grid_ColumnChooser_AddColumn: _TL_('Add'),
  Grid_ColumnChooser_Apply: _TL_('Apply'),
  Grid_ColumnChooser_Cancel: _TL_('Cancel'),
  Grid_ColumnChooser_ColumnAdded: _TL_('Added'),
  Grid_ColumnChooser_ColumnSetNameAlreadyExists_New: _TL_('There is already a set of columns with this name: {{name}}'),
  Grid_ColumnChooser_Header: _TL_('Add or remove columns'),
  Grid_ColumnChooser_Header_Title: _TL_('Modify columns'),
  Grid_ColumnChooser_RemoveAll: _TL_('Remove all'),
  Grid_ColumnChooser_RemoveAllColumns: _TL_('Remove all columns'),
  Grid_ColumnChooser_RemoveColumn: _TL_('Remove'),
  Grid_ColumnChooser_ReplaceColumnSetName: _TL_('Do you want to replace it?'),
  Grid_ColumnChooser_Save: _TL_('OK'),
  Grid_ColumnChooser_SaveColumnSet: _TL_('Save this set of columns'),
  Grid_ColumnChooser_SelectedColumnsWithReorder: _TL_('Selected columns (drag and drop to reorder)'),
  Grid_Edit_Cell: _TL_('Edit cell of column {{columnName}} and row {{rowIndex}}'),
  Grid_RowSelectionRequired: _TL_('There are no rows selected. Please select one or more rows first.'),
  Grid_SelectColumns: _TL_('Columns'),
  Grid_ShowRows: _TL_('Show rows:'),
  InlineReportDownload_Download_Button: _TL_('Download'),
  ItemAttributes: _TL_('Item attributes'),
  Keyword_AddAllText: _TL_('Add all'),
  LevelOfDetails: _TL_('Level of details'),
  Loading: _TL_('Loading...'),
  LocationTargeting_TargetTypeCity: _TL_('city'),
  LocationTargeting_TargetTypeCountry: _TL_('country/region'),
  LocationTargeting_TargetTypeCounty: _TL_('county'),
  LocationTargeting_TargetTypeDMA: _TL_('Nielsen DMA®'),
  LocationTargeting_TargetTypeMetroArea: _TL_('metro area'),
  LocationTargeting_TargetTypePostalCode: _TL_('zip code'),
  LocationTargeting_TargetTypeSubGeography: _TL_('state/province'),
  MRCAccredited_Label_TimeZone: _TL_('Only clicks are MRC accredited. {{timezone}}'),
  'No results found for {{searchText}}': _TL_('No results found for {{searchText}}'),
  'No results to display.': _TL_('No results to display.'),
  PageEntity_AdCustomizerFeed_Label: _TL_('Ad customizer feed'),
  PageEntity_DynamicDataFeed_Label: _TL_('Dynamic data feed'),
  PageEntity_PageFeed_Label: _TL_('Page feed'),
  PageTitle_AdCustomizerFeed_Name_Label: _TL_('Ad customizer feed name'),
  PageTitle_DynamicDataFeed_Name_Label: _TL_('Dynamic data feed name'),
  PageTitle_PageFeed_Name_Label: _TL_('Page feed name'),
  Page_ShowReport_lblColumnFromList: _TL_('Available columns'),
  Page_ShowReport_lblColumnToList: _TL_('Selected columns'),
  Performance: _TL_('Performance'),
  PhysicalLocation: _TL_('Physical location'),
  PublisherCountry_Algeria: _TL_('Algeria'),
  PublisherCountry_Argentina: _TL_('Argentina'),
  PublisherCountry_Australia: _TL_('Australia'),
  PublisherCountry_Austria: _TL_('Austria'),
  PublisherCountry_Bahrain: _TL_('Bahrain'),
  PublisherCountry_Brazil: _TL_('Brazil'),
  PublisherCountry_Canada: _TL_('Canada'),
  PublisherCountry_Chile: _TL_('Chile'),
  PublisherCountry_China: _TL_('China'),
  PublisherCountry_Colombia: _TL_('Colombia'),
  PublisherCountry_Denmark: _TL_('Denmark'),
  PublisherCountry_Egypt: _TL_('Egypt'),
  PublisherCountry_Finland: _TL_('Finland'),
  PublisherCountry_France: _TL_('France'),
  PublisherCountry_Germany: _TL_('Germany'),
  PublisherCountry_HongKong_SAR: _TL_('Hong Kong SAR'),
  PublisherCountry_India: _TL_('India'),
  PublisherCountry_Indonesia: _TL_('Indonesia'),
  PublisherCountry_Iraq: _TL_('Iraq'),
  PublisherCountry_Ireland: _TL_('Ireland'),
  PublisherCountry_Italy: _TL_('Italy'),
  PublisherCountry_Jordan: _TL_('Jordan'),
  PublisherCountry_Kuwait: _TL_('Kuwait'),
  PublisherCountry_Lebanon: _TL_('Lebanon'),
  PublisherCountry_Libya: _TL_('Libya'),
  PublisherCountry_Malaysia: _TL_('Malaysia'),
  PublisherCountry_Mexico: _TL_('Mexico'),
  PublisherCountry_Morocco: _TL_('Morocco'),
  PublisherCountry_Netherlands: _TL_('Netherlands'),
  PublisherCountry_NewZealand: _TL_('New Zealand'),
  PublisherCountry_Norway: _TL_('Norway'),
  PublisherCountry_Oman: _TL_('Oman'),
  PublisherCountry_Peru: _TL_('Peru'),
  PublisherCountry_Philippines: _TL_('Philippines'),
  PublisherCountry_Qatar: _TL_('Qatar'),
  PublisherCountry_SaudiArabia: _TL_('Saudi Arabia'),
  PublisherCountry_Singapore: _TL_('Singapore'),
  PublisherCountry_Spain: _TL_('Spain'),
  PublisherCountry_Sweden: _TL_('Sweden'),
  PublisherCountry_Switzerland: _TL_('Switzerland'),
  PublisherCountry_Taiwan: _TL_('Taiwan'),
  PublisherCountry_Thailand: _TL_('Thailand'),
  PublisherCountry_Tunisia: _TL_('Tunisia'),
  PublisherCountry_UK: _TL_('United Kingdom'),
  PublisherCountry_US: _TL_('United States'),
  PublisherCountry_UnitedArabEmirates: _TL_('United Arab Emirates'),
  PublisherCountry_Venezuela: _TL_('Venezuela'),
  PublisherCountry_Vietnam: _TL_('Vietnam'),
  PublisherCountry_Yemen: _TL_('Yemen'),
  RejectionCountriesText: _TL_('Countries/Regions:'),
  RejectionHeaderTextForFeedItem: _TL_('Your feed item has been disapproved because it may violate our advertising policies.'),
  RejectionPolicyViolationText: _TL_('Policy Violation'),
  RejectionStaticLinkFooterText: _TL_('If you feel your content falls within our policies, please contact <a href="http://go.microsoft.com/fwlink/?LinkId=506728"),>Microsoft Advertising support</a> and we\'ll be happy to review the content again.'),
  Schema_Adgroup_Property_AdgroupName: _TL_('Target ad group'),
  Schema_Audience_Property_AudienceId: _TL_('Target audience ID'),
  Schema_Campaign_Property_CampaignName: _TL_('Target campaign'),
  Schema_Enum_DevicePreference_All: _TL_('All'),
  Schema_Enum_DevicePreference_Mobile: _TL_('Mobile'),
  Schema_Enum_EditorialStatus_Approved: _TL_('Eligible'),
  Schema_Enum_EditorialStatus_ApprovedLimited: _TL_('Approved limited'),
  Schema_Enum_EditorialStatus_Pending: _TL_('Pending editorial review'),
  Schema_Enum_EditorialStatus_Rejected: _TL_('Disapproved'),
  Schema_Enum_FeedAttributeType_DateTime: _TL_('date'),
  Schema_Enum_FeedAttributeType_Int64: _TL_('number'),
  Schema_Enum_FeedAttributeType_Price: _TL_('price'),
  Schema_Enum_FeedAttributeType_String: _TL_('text'),
  Schema_Enum_LocationRestriction_Physical: _TL_('Physical location'),
  Schema_Enum_MatchType_Broad: _TL_('Broad'),
  Schema_Enum_MatchType_Exact: _TL_('Exact'),
  Schema_Enum_MatchType_Phrase: _TL_('Phrase'),
  Schema_FeedItem_Property_AdGroupName: _TL_('Ad group'),
  Schema_FeedItem_Property_AdId: _TL_('Ad Id'),
  Schema_FeedItem_Property_AttributeValues: _TL_('Item attribute values'),
  Schema_FeedItem_Property_CampaignName: _TL_('Campaign'),
  Schema_FeedItem_Property_DevicePreference: _TL_('Device preference'),
  Schema_FeedItem_Property_EditorialStatus: _TL_('Delivery'),
  Schema_FeedItem_Property_EndDate: _TL_('End date'),
  Schema_FeedItem_Property_Id: _TL_('Item ID'),
  Schema_FeedItem_Property_Schedule: _TL_('Scheduling'),
  Schema_FeedItem_Property_StartDate: _TL_('Start date'),
  Schema_FeedItem_Property_Status: _TL_('Status'),
  Schema_FeedItem_Property_TargetAdgroup: _TL_('Target ad group'),
  Schema_FeedItem_Property_TargetAudience: _TL_('Target audience ID'),
  Schema_FeedItem_Property_TargetCampaign: _TL_('Target campaign'),
  Schema_FeedItem_Property_TargetKeyword: _TL_('Target keyword'),
  Schema_FeedItem_Property_TargetLocation: _TL_('Target location'),
  Schema_FeedItem_Property_TargetLocationRestriction: _TL_('Target location restriction'),
  Schema_FeedUploadSummary_Property_AdditionCount: _TL_('Additions'),
  Schema_FeedUploadSummary_Property_ChangeCount: _TL_('Changes'),
  Schema_FeedUploadSummary_Property_ErrorCount: _TL_('Errors'),
  Schema_FeedUploadSummary_Property_Preview_1000Row: _TL_('Previewed first 1000 rows'),
  Schema_FeedUploadSummary_Property_RemoveCount: _TL_('Removals'),
  Schema_FeedUploadSummary_Property_SuccessCount_Apply: _TL_('Success count'),
  Schema_FeedUploadSummary_Property_SuccessCount_Preview: _TL_('Valid count'),
  Schema_FeedUploadTaskDetailBase_Property_Actions: _TL_('Actions'),
  Schema_FeedUploadTaskDetailBase_Property_DateTime: _TL_('Date & time'),
  Schema_FeedUploadTaskDetailBase_Property_Summary: _TL_('Summary'),
  Schema_FeedUploadTaskDetailBase_Property_UploadedFileName: _TL_('File uploaded'),
  Schema_Keyword_Property_MatchType: _TL_('Target keyword match type'),
  Schema_Keyword_Property_Text: _TL_('Target keyword text'),
  Schema_Location_Property_DisplayName: _TL_('Target location'),
  Schema_Location_Property_LocationRestriction: _TL_('Target location restriction'),
  Schema_PerformanceMetrics_Property_AdvertiserReportedRevenue: _TL_('Revenue'),
  Schema_PerformanceMetrics_Property_AllConversionAdvertiserReportedRevenue: _TL_('All conv. revenue'),
  Schema_PerformanceMetrics_Property_AllConversionCPA: _TL_('All conv. CPA'),
  Schema_PerformanceMetrics_Property_AllConversionRate: _TL_('All conv. rate'),
  Schema_PerformanceMetrics_Property_AllConversionRevenueOnAdSpend: _TL_('All conv. return on ad spend'),
  Schema_PerformanceMetrics_Property_AllConversions: _TL_('All conv.'),
  Schema_PerformanceMetrics_Property_AuctionLostToAdQualityPercent: _TL_('IS lost to expected CTR'),
  Schema_PerformanceMetrics_Property_AuctionLostToBidPercent: _TL_('IS lost to bid'),
  Schema_PerformanceMetrics_Property_AuctionLostToBudgetPercent: _TL_('IS lost to budget'),
  Schema_PerformanceMetrics_Property_AuctionLostToLandingPercent: _TL_('Compare to IS lost to ad relevance'),
  Schema_PerformanceMetrics_Property_AuctionLostToRankPercent: _TL_('IS lost to rank'),
  Schema_PerformanceMetrics_Property_AuctionWonPercent: _TL_('Impr. share'),
  Schema_PerformanceMetrics_Property_AverageCPC: _TL_('Avg. CPC'),
  Schema_PerformanceMetrics_Property_AverageCPM: _TL_('Avg. CPM'),
  Schema_PerformanceMetrics_Property_AveragePosition: _TL_('Avg. pos.'),
  Schema_PerformanceMetrics_Property_CPA: _TL_('CPA'),
  Schema_PerformanceMetrics_Property_CTR: _TL_('CTR'),
  Schema_PerformanceMetrics_Property_ClickSharePercent: _TL_('Click Share'),
  Schema_PerformanceMetrics_Property_Clicks: _TL_('Clicks'),
  Schema_PerformanceMetrics_Property_ConversionRate: _TL_('Conv. rate'),
  Schema_PerformanceMetrics_Property_Conversions: _TL_('Conv.'),
  Schema_PerformanceMetrics_Property_CustomColumns: _TL_('CustomColumns'),
  Schema_PerformanceMetrics_Property_Impressions: _TL_('Impr.'),
  Schema_PerformanceMetrics_Property_RevenueOnAdSpend: _TL_('Return on ad spend'),
  Schema_PerformanceMetrics_Property_SegmentedData: _TL_('SegmentedData'),
  Schema_PerformanceMetrics_Property_Spend: _TL_('Spend'),
  Schema_PerformanceMetrics_Property_WebsiteCoverage: _TL_('Website coverage'),
  Schema_Platform_Property_DevicePreference: _TL_('Device preference'),
  Schema_Scheduling_Property_EndDate: _TL_('End date'),
  Schema_Scheduling_Property_StartDate: _TL_('Start date'),
  Select: _TL_('select'),
  Summary_DeletedTotal: _TL_('Deleted items total'),
  TimeZoneId_1: _TL_('(GMT+13:00) Nuku\'alofa'),
  TimeZoneId_2: _TL_('(GMT+12:00) Fiji, Kamchatka, Marshall Is.'),
  TimeZoneId_3: _TL_('(GMT+12:00) Auckland, Wellington'),
  TimeZoneId_4: _TL_('(GMT+11:00) Magadan, Solomon Is., New Caledonia'),
  TimeZoneId_5: _TL_('(GMT+10:00) Vladivostok'),
  TimeZoneId_6: _TL_('(GMT+10:00) Hobart'),
  TimeZoneId_7: _TL_('(GMT+10:00) Guam, Port Moresby'),
  TimeZoneId_8: _TL_('(GMT+10:00) Canberra, Melbourne, Sydney'),
  TimeZoneId_9: _TL_('(GMT+10:00) Brisbane'),
  TimeZoneId_10: _TL_('(GMT+09:30) Darwin'),
  TimeZoneId_11: _TL_('(GMT+09:30) Adelaide'),
  TimeZoneId_12: _TL_('(GMT+09:00) Yakutsk'),
  TimeZoneId_13: _TL_('(GMT+09:00) Seoul'),
  TimeZoneId_14: _TL_('(GMT+09:00) Osaka, Sapporo, Tokyo'),
  TimeZoneId_15: _TL_('(GMT+08:00) Taipei'),
  TimeZoneId_16: _TL_('(GMT+08:00) Perth'),
  TimeZoneId_17: _TL_('(GMT+08:00) Kuala Lumpur, Singapore'),
  TimeZoneId_18: _TL_('(GMT+08:00) Irkutsk, Ulaan Bataar'),
  TimeZoneId_19: _TL_('(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi'),
  TimeZoneId_20: _TL_('(GMT+07:00) Krasnoyarsk'),
  TimeZoneId_21: _TL_('(GMT+07:00) Bangkok, Hanoi, Jakarta'),
  TimeZoneId_22: _TL_('(GMT+06:30) Yangon'),
  TimeZoneId_23: _TL_('(GMT+06:00) Sri Jayawardenepura'),
  TimeZoneId_24: _TL_('(GMT+06:00) Nur Sultan, Dhaka'),
  TimeZoneId_25: _TL_('(GMT+06:00) Almaty, Novosibirsk'),
  TimeZoneId_26: _TL_('(GMT+05:45) Kathmandu'),
  TimeZoneId_27: _TL_('(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi'),
  TimeZoneId_28: _TL_('(GMT+05:00) Islamabad, Karachi, Tashkent'),
  TimeZoneId_29: _TL_('(GMT+05:00) Ekaterinburg'),
  TimeZoneId_30: _TL_('(GMT+04:30) Kabul'),
  TimeZoneId_31: _TL_('(GMT+04:00) Baku, Tbilisi, Yerevan'),
  TimeZoneId_32: _TL_('(GMT+04:00) Abu Dhabi, Muscat'),
  TimeZoneId_33: _TL_('(GMT+03:30) Tehran'),
  TimeZoneId_34: _TL_('(GMT+03:00) Nairobi'),
  TimeZoneId_35: _TL_('(GMT+03:00) Moscow, St. Petersburg, Volgograd'),
  TimeZoneId_36: _TL_('(GMT+03:00) Kuwait, Riyadh'),
  TimeZoneId_37: _TL_('(GMT+03:00) Baghdad'),
  TimeZoneId_38: _TL_('(GMT+02:00) Jerusalem'),
  TimeZoneId_39: _TL_('(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius'),
  TimeZoneId_40: _TL_('(GMT+02:00) Harare, Pretoria'),
  TimeZoneId_41: _TL_('(GMT+02:00) Cairo'),
  TimeZoneId_42: _TL_('(GMT+02:00) Bucharest'),
  TimeZoneId_43: _TL_('(GMT+02:00) Athens, Istanbul, Minsk'),
  TimeZoneId_44: _TL_('(GMT+01:00) West Central Africa'),
  TimeZoneId_45: _TL_('(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb'),
  TimeZoneId_46: _TL_('(GMT+01:00) Brussels, Copenhagen, Madrid, Paris'),
  TimeZoneId_47: _TL_('(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague'),
  TimeZoneId_48: _TL_('(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'),
  TimeZoneId_49: _TL_('(GMT) Casablanca, Monrovia'),
  TimeZoneId_50: _TL_('(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London'),
  TimeZoneId_51: _TL_('(GMT-01:00) Azores'),
  TimeZoneId_52: _TL_('(GMT-01:00) Cabo Verde'),
  TimeZoneId_53: _TL_('(GMT-02:00) Mid-Atlantic'),
  TimeZoneId_54: _TL_('(GMT-03:00) Brasilia'),
  TimeZoneId_55: _TL_('(GMT-03:00) Buenos Aires, Georgetown'),
  TimeZoneId_56: _TL_('(GMT-03:00) Greenland'),
  TimeZoneId_57: _TL_('(GMT-03:30) Newfoundland'),
  TimeZoneId_58: _TL_('(GMT-04:00) Atlantic Time (Canada)'),
  TimeZoneId_59: _TL_('(GMT-04:00) Caracas, La Paz'),
  TimeZoneId_60: _TL_('(GMT-03:00) Santiago'),
  TimeZoneId_61: _TL_('(GMT-05:00) Bogota, Lima, Quito'),
  TimeZoneId_62: _TL_('(GMT-05:00) Eastern Time (U.S. & Canada)'),
  TimeZoneId_63: _TL_('(GMT-05:00) Indiana (East)'),
  TimeZoneId_64: _TL_('(GMT-06:00) Central America'),
  TimeZoneId_65: _TL_('(GMT-06:00) Central Time (U.S. & Canada)'),
  TimeZoneId_66: _TL_('(GMT-06:00) Guadalajara, Mexico City, Monterrey'),
  TimeZoneId_67: _TL_('(GMT-06:00) Saskatchewan'),
  TimeZoneId_68: _TL_('(GMT-07:00) Arizona'),
  TimeZoneId_69: _TL_('(GMT-07:00) Chihuahua, La Paz, Mazatlan'),
  TimeZoneId_70: _TL_('(GMT-07:00) Mountain Time (U.S. & Canada)'),
  TimeZoneId_71: _TL_('(GMT-08:00) Pacific Time (U.S. & Canada); Tijuana'),
  TimeZoneId_72: _TL_('(GMT-09:00) Alaska'),
  TimeZoneId_73: _TL_('(GMT-10:00) Hawaii'),
  TimeZoneId_74: _TL_('(GMT-11:00) Midway Island, Samoa'),
  TimeZoneId_75: _TL_('(GMT-12:00) International Date Line West'),
  TimeZone_AbuDhabiMuscat: _TL_('{0}{1}(GMT+04:00) Abu Dhabi, Muscat'),
  TimeZone_Adelaide: _TL_('{0}{1}(GMT+09:30) Adelaide'),
  TimeZone_Alaska: _TL_('{0}{1}(GMT-09:00) Alaska'),
  TimeZone_Almaty_Novosibirsk: _TL_('{0}{1}(GMT+06:00) Almaty, Novosibirsk'),
  TimeZone_AmsterdamBerlinBernRomeStockholmVienna: _TL_('{0}{1}(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'),
  TimeZone_Arizona: _TL_('{0}{1}(GMT-07:00) Arizona'),
  TimeZone_AstanaDhaka: _TL_('{0}{1}(GMT+06:00) Nur Sultan, Dhaka'),
  TimeZone_AthensIslandanbulMinsk: _TL_('{0}{1}(GMT+02:00) Athens, Istanbul, Minsk'),
  TimeZone_AtlanticTimeCanada: _TL_('{0}{1}(GMT-04:00) Atlantic Time (Canada)'),
  TimeZone_AucklandWellington: _TL_('{0}{1}(GMT+12:00) Auckland, Wellington'),
  TimeZone_Azores: _TL_('{0}{1}(GMT-01:00) Azores'),
  TimeZone_Baghdad: _TL_('{0}{1}(GMT+03:00) Baghdad'),
  TimeZone_BakuTbilisiYerevan: _TL_('{0}{1}(GMT+04:00) Baku, Tbilisi, Yerevan'),
  TimeZone_BangkokHanoiJakarta: _TL_('{0}{1}(GMT+07:00) Bangkok, Hanoi, Jakarta'),
  TimeZone_BeijingChongqingHongKongUrumqi: _TL_('{0}{1}(GMT+08:00) Beijing, Chongqing, Hong Kong SAR, Urumqi'),
  TimeZone_BelgradeBratislavaBudapestLjubljanaPrague: _TL_('{0}{1}(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague'),
  TimeZone_BogotaLimaQuito: _TL_('{0}{1}(GMT-05:00) Bogota, Lima, Quito'),
  TimeZone_Brasilia: _TL_('{0}{1}(GMT-03:00) Brasilia'),
  TimeZone_Brisbane: _TL_('{0}{1}(GMT+10:00) Brisbane'),
  TimeZone_BrusselsCopenhagenMadridParis: _TL_('{0}{1}(GMT+01:00) Brussels, Copenhagen, Madrid, Paris'),
  TimeZone_Bucharest: _TL_('{0}{1}(GMT+02:00) Bucharest'),
  TimeZone_BuenosAiresGeorgetown: _TL_('{0}{1}(GMT-03:00) Buenos Aires, Georgetown'),
  TimeZone_Cairo: _TL_('{0}{1}(GMT+02:00) Cairo'),
  TimeZone_CanberraMelbourneSydney: _TL_('{0}{1}(GMT+10:00) Canberra, Melbourne, Sydney'),
  TimeZone_CapeVerdeIsland: _TL_('{0}{1}(GMT-01:00) Cabo Verde'),
  TimeZone_CaracasLaPaz: _TL_('{0}{1}(GMT-04:00) Caracas, La Paz'),
  TimeZone_CasablancaMonrovia: _TL_('{0}{1}(GMT) Casablanca, Monrovia'),
  TimeZone_CentralAmerica: _TL_('{0}{1}(GMT-06:00) Central America'),
  TimeZone_CentralTimeUSCanada: _TL_('{0}{1}(GMT-06:00) Central Time (U.S. & Canada)'),
  TimeZone_ChennaiKolkataMumbaiNewDelhi: _TL_('{0}{1}(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi'),
  TimeZone_ChihuahuaLaPazMazatlan: _TL_('{0}{1}(GMT-07:00) Chihuahua, La Paz, Mazatlan'),
  TimeZone_Darwin: _TL_('{0}{1}(GMT+09:30) Darwin'),
  TimeZone_EasternTimeUSCanada: _TL_('{0}{1}(GMT-05:00) Eastern Time (U.S. & Canada)'),
  TimeZone_Ekaterinburg: _TL_('{0}{1}(GMT+05:00) Ekaterinburg'),
  TimeZone_FijiKamchatkaMarshallIsland: _TL_('{0}{1}(GMT+12:00) Fiji, Kamchatka, Marshall Is.'),
  TimeZone_Greenland: _TL_('{0}{1}(GMT-03:00) Greenland'),
  TimeZone_GreenwichMeanTimeDublinEdinburghLisbonLondon: _TL_('{0}{1}(GMT) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London'),
  TimeZone_GuadalajaraMexicoCityMonterrey: _TL_('{0}{1}(GMT-06:00) Guadalajara, Mexico City, Monterrey'),
  TimeZone_GuamPortMoresby: _TL_('{0}{1}(GMT+10:00) Guam, Port Moresby'),
  TimeZone_HararePretoria: _TL_('{0}{1}(GMT+02:00) Harare, Pretoria'),
  TimeZone_Hawaii: _TL_('{0}{1}(GMT-10:00) Hawaii'),
  TimeZone_HelsinkiKyivRigaSofiaTallinnVilnius: _TL_('{0}{1}(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius'),
  TimeZone_Hobart: _TL_('{0}{1}(GMT+10:00) Hobart'),
  TimeZone_IndianaEast: _TL_('{0}{1}(GMT-05:00) Indiana (East)'),
  TimeZone_InternationalDateLineWest: _TL_('{0}{1}(GMT-12:00) International Date Line West'),
  TimeZone_IrkutskUlaanBataar: _TL_('{0}{1}(GMT+08:00) Irkutsk, Ulaan Bataar'),
  TimeZone_IslandamabadKarachiTashkent: _TL_('{0}{1}(GMT+05:00) Islamabad, Karachi, Tashkent'),
  TimeZone_Jerusalem: _TL_('{0}{1}(GMT+02:00) Jerusalem'),
  TimeZone_Kabul: _TL_('{0}{1}(GMT+04:30) Kabul'),
  TimeZone_Kathmandu: _TL_('{0}{1}(GMT+05:45) Kathmandu'),
  TimeZone_Krasnoyarsk: _TL_('{0}{1}(GMT+07:00) Krasnoyarsk'),
  TimeZone_KualaLumpurSingapore: _TL_('{0}{1}(GMT+08:00) Kuala Lumpur, Singapore'),
  TimeZone_KuwaitRiyadh: _TL_('{0}{1}(GMT+03:00) Kuwait, Riyadh'),
  TimeZone_MagadanSolomonIslandNewCaledonia: _TL_('{0}{1}(GMT+11:00) Magadan, Solomon Is., New Caledonia'),
  TimeZone_MidAtlantic: _TL_('{0}{1}(GMT-02:00) Mid-Atlantic'),
  TimeZone_MidwayIslandand_Samoa: _TL_('{0}{1}(GMT-11:00) Midway Island, Samoa'),
  TimeZone_MoscowStPetersburgVolgograd: _TL_('{0}{1}(GMT+03:00) Moscow, St. Petersburg, Volgograd'),
  TimeZone_MountainTime_US_Canada: _TL_('{0}{1}(GMT-07:00) Mountain Time (U.S. & Canada)'),
  TimeZone_Nairobi: _TL_('{0}{1}(GMT+03:00) Nairobi'),
  TimeZone_Newfoundland: _TL_('{0}{1}(GMT-03:30) Newfoundland'),
  TimeZone_Nukualofa: _TL_('{0}{1}(GMT+13:00) Nuku\'alofa'),
  TimeZone_OsakaSapporoTokyo: _TL_('{0}{1}(GMT+09:00) Osaka, Sapporo, Tokyo'),
  TimeZone_PacificTimeUSCanadaTijuana: _TL_('{0}{1}(GMT-08:00) Pacific Time (U.S. & Canada); Tijuana'),
  TimeZone_Perth: _TL_('{0}{1}(GMT+08:00) Perth'),
  TimeZone_Rangoon: _TL_('{0}{1}(GMT+06:30) Yangon'),
  TimeZone_Santiago: _TL_('{0}{1}(GMT-03:00) Santiago'),
  TimeZone_SarajevoSkopjeWarsawZagreb: _TL_('{0}{1}(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb'),
  TimeZone_Saskatchewan: _TL_('{0}{1}(GMT-06:00) Saskatchewan'),
  TimeZone_Seoul: _TL_('{0}{1}(GMT+09:00) Seoul'),
  TimeZone_SriJayawardenepura: _TL_('{0}{1}(GMT+06:00) Sri Jayawardenepura'),
  TimeZone_Taipei: _TL_('{0}{1}(GMT+08:00) Taipei'),
  TimeZone_Tehran: _TL_('{0}{1}(GMT+03:30) Tehran'),
  TimeZone_Vladivostok: _TL_('{0}{1}(GMT+10:00) Vladivostok'),
  TimeZone_WestCentralAfrica: _TL_('{0}{1}(GMT+01:00) West Central Africa'),
  TimeZone_Yakutsk: _TL_('{0}{1}(GMT+09:00) Yakutsk'),
  Validation_Base_Field_Not_Valid: _TL_('Field is not valid'),
  Validation_NotEmpty_Required_Field: _TL_('Required field'),
  Validation_String_Invalid_Characters: _TL_('Field contains invalid characters'),
  Validation_String_Max_Length: _TL_('Field should not exceed {{maxlength}} characters'),
  '{{tableName}} table header': _TL_('{{tableName}} table header'),
  'Select all': _TL_('Select all'),
  'Select an ad group': _TL_('Select an ad group'),
  'Select this row': _TL_('Select this row'),
};
